// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionOperators_PerformanceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for GET /so/production_operators/performance
 *
 * Returns per-operator performance metrics. Wire shape:
 * `dados: ProductionOperators_PerformanceRow[]`.
 *
 * @see ProductionOperators_PerformanceRow
 * @see So_production_operators_model::getPerformance()
 */
import type { ProductionOperators_PerformanceRow } from './ProductionOperators_PerformanceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ProductionOperators_PerformanceResponseDados = ProductionOperators_PerformanceRow[];

export type ProductionOperators_PerformanceResponse = ApiResponse<ProductionOperators_PerformanceResponseDados>;

registerResponseContract('ProductionOperators_PerformanceResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      production_operator_id: { type: 'number',  required: true },
      display_name:           { type: 'string',  required: true },
      color_hex:              { type: 'string',  required: true },
      total_scans:            { type: 'number',  required: true },
      steps_completed:        { type: 'number',  required: true },
      rework:                 { type: 'number',  required: true },
      avg_time_seconds:       { type: 'number',  required: false },
    },
  },
})
